import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  isMobileBreakpoint,
  subscribeToMobileBreakpointChange,
} from '@/shared/utils/media';

interface UIState {
  sidebarCollapsed: boolean;
  loading: boolean;
  currentFunction: string;
  toggleSidebar: () => void;
  setLoading: (loading: boolean) => void;
  setCurrentFunction: (functionName: string) => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    set => ({
      // Initialize `sidebarCollapsed` based on viewport. If running on the
      // server `window` is undefined so `isMobileBreakpoint` returns `false`.
      sidebarCollapsed: isMobileBreakpoint(),
      loading: false,
      currentFunction: '',
      toggleSidebar: () =>
        set(
          state => ({ sidebarCollapsed: !state.sidebarCollapsed }),
          false,
          'ui/toggleSidebar',
        ),
      setLoading: loading => set({ loading }, false, 'ui/setLoading'),
      setCurrentFunction: functionName =>
        set({ currentFunction: functionName }, false, 'ui/setCurrentFunction'),
    }),
    {
      name: 'ui-store',
    },
  ),
);

// Keep `sidebarCollapsed` in sync with the media query. Subscription is
// started in the browser at module load; `subscribeToMobileBreakpointChange`
// returns an unsubscribe function but we intentionally let it live for the
// app lifetime (store is global).
if (typeof window !== 'undefined') {
  subscribeToMobileBreakpointChange(isMobile => {
    useUIStore.setState(
      { sidebarCollapsed: isMobile },
      false,
      'ui/mediaQueryChange',
    );
  });
}
